(() => {
  const IDS = {
    foundations: ['10053345476914', '50668119818546'],
    'tools-of-the-technician': ['10093719781682', '50864686825778'],
    'elegance-in-motion': ['15425135968562', '67954439651634']
  };
  const courseRoute = value => {
    const match = /^#course\/([a-z0-9-]+)(?:\/lesson\/([a-z0-9-]+))?$/.exec(value || '');
    return match && Object.hasOwn(IDS, match[1]) ? match[1] : null;
  };
  if (typeof module === 'object' && module.exports) module.exports = { courseRoute };
  if (typeof document === 'undefined') return;

  const initialize = root => {
    const academy = root.closest('[data-academy]');
    if (!academy || root.dataset.initialized || root.dataset.theme !== academy.dataset.theme) return;
    root.dataset.initialized = 'true';
    const products = JSON.parse(root.querySelector('[data-paid-catalog]').textContent);
    const labels = JSON.parse(root.querySelector('[data-paid-labels]').textContent);
    let sequence = 0;

    const synchronize = () => {
      for (const [id, product] of Object.entries(products)) {
        const price = academy.querySelector('[data-course-price="' + id + '"]');
        if (price && product.price) price.content.textContent = product.price;
      }
      const id = courseRoute(location.hash), product = products[id];
      if (!id || product?.product !== IDS[id][0] || product?.variant !== IDS[id][1]) return;
      const template = root.querySelector('[data-paid-product-form="' + id + '"]');
      for (const original of academy.querySelectorAll('[data-course-purchase]')) {
        // Templates stay inert; only replace the currently rendered sales controls.
        const existingForm = original.closest('form[data-academy-cart-form]');
        const ready = root.dataset.enabled === 'true' && product.checkout_enabled === true
          && product.available === true && product.has_access !== true && template;
        if (!ready) {
          original.disabled = true;
          original.removeAttribute('aria-haspopup');
          original.title = product.has_access ? labels.complete : labels.unavailable;
          if (existingForm) existingForm.querySelector('[name="id"]').disabled = true;
          continue;
        }
        const form = template.content.firstElementChild.cloneNode(true);
        if (String(form.querySelector('[name="id"]').value) !== IDS[id][1]) continue;
        form.id += '-' + (++sequence);
        const button = form.querySelector('[type="submit"]');
        button.className += ' ' + original.className;
        if (original.hasAttribute('data-sales-paid')) button.setAttribute('data-sales-paid', '');
        form.querySelector('[name="id"]').disabled = false;
        (existingForm || original).replaceWith(form);
      }
    };
    window.addEventListener('hashchange', () => queueMicrotask(synchronize));
    queueMicrotask(synchronize);
  };
  document.querySelectorAll('[data-academy-purchase]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-academy-purchase]').forEach(initialize);
  });
})();
